<template>
  <main>
    <!-- Main Content -->
    <section class="container mx-auto mt-6">
      <div class="md:grid md:grid-cols-3 md:gap-4">
        <div class="col-span-1">
          <app-upload ref="upload" :addSong="addSong" />
        </div>
        <div class="col-span-2">
          <div
            class="
              bg-white
              rounded
              border border-gray-200
              relative
              flex flex-col
            "
          >
            <div class="px-6 pt-6 pb-5 font-bold border-b border-gray-200">
              <span class="card-title">My Songs</span>
              <i
                class="fa fa-compact-disc float-right text-green-400 text-2xl"
              ></i>
            </div>
            <div class="p-6">
              <composition-item
                v-for="(song, i) in songsList"
                :key="song.docID"
                :song="song"
                :index="i"
                :updateSong="updateSong"
                :removeSong="removeSong"
                :updateUnsavedFlag="updateUnsavedFlag"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// import store from '@/store';
import AppUpload from '@/components/Upload.vue';
import CompositionItem from '@/components/CompositionItem.vue';
import { songsCollection, auth } from '@/includes/firebase';

export default {
  name: 'manage',
  components: {
    AppUpload,
    CompositionItem,
  },
  data() {
    return {
      songsList: [],
      unsavedFlag: false,
    };
  },
  async created() {
    const snapshot = await songsCollection.where('uid', '==', auth.currentUser.uid).get();

    snapshot.forEach(this.addSong);
  },
  methods: {
    updateSong(i, values) {
      this.songsList[i].modified_name = values.modified_name;
      this.songsList[i].genre = values.genre;
    },
    removeSong(i) {
      this.songsList.splice(i, 1);
    },
    addSong(doc) {
      const song = {
        ...doc.data(),
        docID: doc.id,
      };

      this.songsList.push(song);
    },
    updateUnsavedFlag(val) {
      this.unsavedFlag = val;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.unsavedFlag) {
      next();
    } else {
      const leave = confirm('You have unsaved changes. Are you sure you want to leave?');
      next(leave);
    }
  },
  //   beforeRouteLeave(to, from, next) {
  //       this.$refs.upload.cancelUploads();
  //       next();
  //   },
  // beforeRouteEnter(to, from, next) {
  //     if (store.state.userLoggedIn) {
  //         next();
  //     } else {
  //         next({ name: 'home' });
  //     }
  // }
};
</script>
